import { useContext, useEffect } from 'react';
import { useFormikContext } from 'formik';
import { Button, CardFooter } from 'reactstrap';
import styled from 'styled-components';

import { MapContext } from '../../../../contexts/MapContext';

const EditorFooter = styled(CardFooter)`
  display: flex;
  justify-content: space-between;
  padding: var(--popup-y-padding) var(--popup-x-padding);
`;

const SaveButton = styled(Button)`
  color: var(--overyield-blue);
`;

const DeleteButton = styled(Button)`
  &:hover {
    color: red;
  }
`;

const NoteEditorToolbar = ({
  readonly,
  onDeleteClick,
  onCloseClick,
  onCloseViewerClick,
  isNewNote,
}) => {
  const { dirty } = useFormikContext();

  const {
    mapState: { setHasDirtyNote },
  } = useContext(MapContext);

  useEffect(() => {
    setHasDirtyNote(dirty);
  }, [dirty]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    return () => setHasDirtyNote(false);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return readonly ? (
    <EditorFooter className="justify-content-end">
      <SaveButton
        color="link"
        onClick={onCloseViewerClick}
        className="p-0 font-weight-bold"
      >
        Close
      </SaveButton>
    </EditorFooter>
  ) : (
    <EditorFooter className={isNewNote && 'justify-content-end'}>
      {!isNewNote && (
        <DeleteButton
          color="link"
          className="p-0 font-weight-bold"
          onClick={onDeleteClick}
        >
          Delete
        </DeleteButton>
      )}
      <span>
        <Button
          color="link"
          onClick={() => onCloseClick(dirty)}
          className={`py-0 font-weight-bold ${!dirty && 'px-0'}`}
        >
          Close
        </Button>
        {dirty && (
          <SaveButton
            color="link"
            className="p-0 font-weight-bold"
            type="submit"
          >
            Save & Close
          </SaveButton>
        )}
      </span>
    </EditorFooter>
  );
};

export default NoteEditorToolbar;
